import defaultHeader from './headers/default-header';

/**
 * Render a grid thead cell based on the `cachedColumn.type`. Falls back to a
 * `defaultHeader` if the type does not require specific rendering logic.
 * @param {CachedColumn} cachedColumn
 * @param {Function} createElement
 * @param {Object|null} sortBy
 * @returns {*}
 */
export default function renderHeaderCell({
    cachedColumn,
    createElement,
    grid,
}) {
    const params = {
        cachedColumn, createElement, grid,
    };
    // fallback to default column rendering
    return createElement(...defaultHeader(params));
}
